import styled from 'styled-components';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cx from 'classnames';
import {
    getBusinessDisplayUnit,
    GetBusinessDisplayUnitResult,
} from '../../../services/business-group.service';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import DefaultBusinessIcon from '../../common/Icons/default-business-icon';
import BusinessListUnitItem from '../BusinessListUnitItem/BusinessListUnitItem';

interface SearchBusinessGroupWithChildItemProps {
    businessGroup: BusinessDisplayUnit;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const StyledSearchBusinessGroupWithChildItem = styled.div`
    border-top: 1px solid #e4dee4;
    .accordion-bgc {
        background-color: rgba(17, 17, 17, 5%);
    }
    .gray-boder {
        border-top: 1px solid gray;
    }
`;

const StyleSearchBusinessGroupWithChildItemTitle = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
    //padding-left: 23px;
    .business-group-logo {
        max-width: 50px;
        max-height: 50px;
        align-self: center;
    }
    .default-business-log {
        width: 50px;
        height: 50px;
    }
    .business-group-list-description {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 20px;
        overflow: hidden;
    }
    .business-group-log {
        width: 50px;
        height: 50px;
    }

    .business-name {
        height: auto;
        width: 280px;
        //text-overflow: ellipsis;
        //overflow: hidden;
        min-width: 0;
        //white-space: nowrap;
        padding-top: 5px;
    }
    .description {
        color: #787878;
        height: auto;
        width: 280px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-top: 5px;
        //display: -webkit-box;
        //-webkit-box-orient: vertical;
        //-webkit-line-clamp: 2;
    }
`;
const StyledAccordion = styled(Accordion)`
    box-shadow: none;
    border: none;
`;
const StyleAccordionSummary = styled(AccordionSummary)`
    height: calc(100% - 20px);
    padding-top: 0px;
    padding-left: 22px;
    border: none;
    .business-name {
        font-weight: bold;
    }
`;
const StyleAccordionDetails = styled(AccordionDetails)`
    display: flex;
    border: none;
    flex-direction: column;
    background-color: rgba(17, 17, 17, 5%);
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 32px;

    .no-business-text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
    }
`;
const SearchBusinessGroupWithChildItem = ({
    businessGroup,
    onSelect,
}: SearchBusinessGroupWithChildItemProps) => {
    const [businessDisplayUnitList, setBusinessDisplayUnitList] = useState<BusinessDisplayUnit[]>(
        [],
    );
    const [isFetchMore, setIsFetchMore] = useState<boolean>(false);
    const [isExpanded, setIsExpanded] = useState(true);
    // const fetchBusinessItem = async () => {
    //     setIsFetchMore(true);
    //     const payLoad = {
    //         businessDisplayGroupId: businessGroup.id,
    //     };
    //     const result: GetBusinessDisplayUnitResult = await getBusinessDisplayUnit(payLoad);
    //     if (result.data) {
    //         setBusinessDisplayUnitList(result.data.businessDisplayUnitList);
    //     }
    //     setIsFetchMore(false);
    // };
    const handleChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        if (isExpanded) {
            setIsExpanded(true);
        } else {
            setIsExpanded(false);
        }
    };
    useEffect(() => {
        setBusinessDisplayUnitList(businessGroup.childBusinessDisplayUnit as BusinessDisplayUnit[]);
    }, [businessGroup]);

    return (
        <StyledSearchBusinessGroupWithChildItem>
            <StyledAccordion expanded={isExpanded} onChange={handleChange}>
                <StyleAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={cx({ 'accordion-bgc': isExpanded})}
                >
                    <StyleSearchBusinessGroupWithChildItemTitle>
                        <div className="business-group-log">
                            {businessGroup.photoURL ? (
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <img className="business-group-logo" src={businessGroup.photoURL} />
                            ) : (
                                <DefaultBusinessIcon className="default-business-log" />
                            )}
                        </div>

                        <div className="business-group-list-description">
                            <div className="business-name">{businessGroup.name}</div>

                            <div className="description">
                                {businessGroup.categoryName
                                    ? businessGroup.categoryName
                                    : businessGroup.categoryTags}
                            </div>
                        </div>
                    </StyleSearchBusinessGroupWithChildItemTitle>
                </StyleAccordionSummary>
                <StyleAccordionDetails>
                    {businessDisplayUnitList.map((businessDisplayUnit) => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <div className={cx('business-list-unit-item-bgc')}>
                                <BusinessListUnitItem
                                    businessDisplayUnit={businessDisplayUnit}
                                    onSelect={onSelect}
                                />
                            </div>
                        );
                    })}
                </StyleAccordionDetails>
            </StyledAccordion>
        </StyledSearchBusinessGroupWithChildItem>
    );
};
export default SearchBusinessGroupWithChildItem;
